import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import "./TreatmentPlanList.css";
import { getPatientAdherance } from "../services/patientService";
import { toast } from "react-toastify";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import HorizontalCalendar from "./HorizontalCalendar";
import { format } from "date-fns";
import Loader from "../../utils/Loader";

export default function AdheranceList({ patient }) {
  const [patientMedicationPlan, setPatientMedicationPlan] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");

  const [loading, setLoading] = useState(false);
  // horizonatl calender
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

  /* Function's */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    fetchPatientAdheranceById(selectedValue);
  }, [page, limit, selectedDate]);

  const fetchPatientAdheranceById = async (eventKey) => {
    try {
      setLoading(true);
      const response = await getPatientAdherance({
        patientId: patient,
        page: page + 1,
        limit,
        searchKey: searchText,
        sortBy: eventKey,
        date: format(new Date(selectedDate), "yyyy-MM-dd"),
      });
      if (response?.status === "SUCCESS") {
        setPatientMedicationPlan(response?.data.list);
        setTotalPages(response?.data?.totalPages || 0);
        setTotalItems(response?.data?.totalItems || 0);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);

      toast.error("Please try again later");
    }
  };

  const handleSelect = (eventKey) => {
    setSelectedValue(eventKey);
    fetchPatientAdheranceById(eventKey);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="Dashboard-lft-blk">
        <div className="lft-blk-top justify-content-between d-flex mb-3">
          <HorizontalCalendar
            selectedDate={selectedDate}
            onDateSelect={setSelectedDate}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
          />

          <div className=" d-flex gap-2">
            {/* Horizontal Calendar Component */}

            <Dropdown
              className="patient-info-dropdown d-flex text-center aling-item-center"
              onSelect={handleSelect}
            >
              <Dropdown.Toggle className="db-dropdown">
                {selectedValue === ""
                  ? "Sort By"
                  : selectedValue === "recent"
                  ? "recent"
                  : "oldest"}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item eventKey="recent">Recent</Dropdown.Item>
                <Dropdown.Item eventKey="oldest">Oldest</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {/* table for tratment lis  */}
        <div className="table-responsive dashboard-table">
          <table className="patients-table">
            <thead>
              <tr className="t-row-block">
                <th scope="col">Sr No</th>

                <th scope="col">Medicine Name</th>
                <th scope="col">Medication Type</th>
                <th scope="col">Medication Strength</th>
                <th scope="col">Time & Date</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {patientMedicationPlan.length > 0 ? (
                patientMedicationPlan?.map((patient, index) => (
                  <tr key={patient.id || index}>
                    <td scope="row" style={{ borderLeft: "0px" }}>
                      {++index}
                    </td>
                    <td>{patient.medicationDetails.medicationName}</td>
                    <td>{patient.medicationDetails.medicationType}</td>
                    <td style={{ borderRight: "0px" }}>
                      {patient.medicationDetails.medicationStrength}{" "}
                      {patient.medicationDetails.medicationUnit}
                    </td>

                    <td style={{ borderRight: "0px" }}>
                      {new Date(patient?.createdAt).toLocaleString("en-US", {
                        hour12: true,
                        year: "numeric",
                        month: "numeric",
                        day: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        // second: '2-digit'
                      })}
                    </td>

                    <td style={{ borderRight: "0px" }}>
                      <span
                        className={`adherence-status adherence-status-${
                          patient.status == "taken"
                            ? "taken"
                            : patient.status == "skip"
                            ? "skip"
                            : "pending"
                        }`}
                      >
                        {patient.status == "taken"
                          ? "Taken"
                          : patient.status == "skip"
                          ? "Skip"
                          : "Remind Me Later"}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No medication Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="pagination-blk">
          <CustomPagination
            totalItems={totalItems}
            page={page}
            onPageChange={handleChangePage}
            limit={limit}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>
    </>
  );
}
